/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener('theme:variant:change', function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  /***************************************/
  /* About Page - Founder Note Font Fix */
  /* Applies Paradine font styles regardless of Translate & Adapt changes */
  document.addEventListener('DOMContentLoaded', function () {
    const founderNoteSection = document.querySelector('[data-section-id$="richtext_NCDFb3"]');
    if (founderNoteSection) {
      const rteDiv = founderNoteSection.querySelector('.rte');
      if (rteDiv) {
        rteDiv.style.maxWidth = '500px';
        rteDiv.style.margin = '0 auto';
        rteDiv.style.setProperty('transform', 'translate(220px, -40px)', 'important');
      }
      const paragraphs = founderNoteSection.querySelectorAll('.rte p');
      paragraphs.forEach(function (p) {
        p.style.color = '#000';
        p.style.textAlign = 'center';
        p.style.fontFamily = 'var(--font-family-paradine)';
        p.style.fontSize = '40px';
        p.style.fontStyle = 'normal';
        p.style.fontWeight = '400';
        p.style.letterSpacing = '4px';
        p.style.lineHeight = '120%';
      });
    }
  });

  /***************************************/
  /* Homepage Hero Content Customization */
  document.addEventListener('DOMContentLoaded', function () {
    const homepageHeroContent = document.querySelector(
      '#homepage-hero-content > .bg-paper > div'
    );
    if (!homepageHeroContent) return;

    const now = new Date();
    const corners = {
      topLeft: 'XXII: Journal Entry',
      topRight:
        now.getFullYear().toString().slice(0, 2) +
        ' ' +
        now.getFullYear().toString().slice(2),
      bottomLeft: now.toLocaleString('default', { month: 'long' }),
      bottomRight: 'Page 01',
    };

    // Function to create a corner element
    function createCorner(text, position) {
      const div = document.createElement('div');
      div.textContent = text;
      div.style.position = 'absolute';
      div.className = 'homepage-hero-content__note-element';

      switch (position) {
        case 'topLeft':
          div.style.top = '0';
          div.style.left = '0';
          div.className += ' homepage-hero-content__note-element--top-left';
          break;
        case 'topRight':
          div.style.top = '0';
          div.style.right = '0';
          div.className += ' homepage-hero-content__note-element--top-right';
          break;
        case 'bottomLeft':
          div.style.bottom = '0';
          div.style.left = '0';
          div.className += ' homepage-hero-content__note-element--bottom-left';
          break;
        case 'bottomRight':
          div.style.bottom = '0';
          div.style.right = '0';
          div.className += ' homepage-hero-content__note-element--bottom-right';
          break;
      }

      return div;
    }

    // Append each corner element to the homepage hero content
    Object.entries(corners).forEach(([key, text]) => {
      homepageHeroContent.appendChild(createCorner(text, key));
    });
  });
})();
